import React from 'react';
import NotificationIcon from '@atlaskit/icon/glyph/notification';
import { useIntl } from '@atlassian/jira-intl';
import { NewField } from '../../../common/ui/new-field';
import messages from './messages';

export const LinkedAlertsField = () => {
	const { formatMessage } = useIntl();

	return (
		<NewField
			icon={<NotificationIcon label="" />}
			title={formatMessage(messages.linkedAlertsSubTitleHeading)}
			description={formatMessage(messages.linkedAlertsSubTitleBody)}
			link={{
				href: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-linked-alerts/',
				text: formatMessage(messages.linkedAlertsLearnMoreLink),
				inProductHelpArticleId: '4bhkXBn8jjqsTRTBXixe35',
			}}
		/>
	);
};
